/**
 * Removes a leading brand prefix ("GV" or "MGBW") followed by spaces or dashes
 * from the supplied text. The match is case-insensitive.
 *
 * Examples:
 *   "GV Some Brand" -> "Some Brand"
 *   "gv-Some Brand" -> "Some Brand"
 *   "MGBW Some Brand" -> "Some Brand"
 *   "No Prefix" -> "No Prefix"
 */
export const stripBrandPrefix = (text: string): string => {
    if (!text) {
        return text;
    }

    return text.replace(/^(?:GV|MGBW)[\s-]+/i, "");
};

export const uppercaseToTitleCase = (text: string): string => {
    const hasCasedCharacters = text.toLocaleLowerCase() !== text.toLocaleUpperCase();
    if (!hasCasedCharacters || text !== text.toLocaleUpperCase()) {
        return text;
    }

    return text
        .toLocaleLowerCase()
        .replace(/(^|[\s/(&-]+)([a-z])/g, (_match, prefix: string, letter: string) => `${prefix}${letter.toUpperCase()}`);
};
